import { KeywordCloud } from "Explore/Components";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./KeywordCloud.module.scss";
import {
  getAuthorKeywordsByID,
  getAuthorGrantsKeywordsByID,
} from "Explore/Services/Author";
const KeywordCloudFacultyDetail = ({
  selectedKeywords,
  setSelectedKeywords,
  sliderValue,
  setSliderValue,
  publicationVerify,
  tab,
}) => {
  const faculty_id = useLocation().pathname.split("/")[3];
  const [concept, setConcept] = useState({ data: [], isLoading: true });
  const [selectedKeywordsQueue, setSelectedKeywordsQueue] = useState([]);
  const [granularityLevel, setGranularityLevel] = useState(1);
  useEffect(() => {
    let params;
    if (selectedKeywordsQueue[selectedKeywordsQueue.length - 1]) {
      params = new URLSearchParams();
      selectedKeywordsQueue[selectedKeywordsQueue.length - 1].forEach(
        (keyword) => {
          if (keyword) {
            params.append("rootConcept", keyword.real_id);
          }
        }
      );
      params = params.toString();
    } else {
      params = null;
    }
    setConcept({ ...concept, isLoading: true });
    if (tab === "grants") {
      getAuthorGrantsKeywordsByID(
        faculty_id,
        sliderValue,
        granularityLevel,
        params,
        (res) => {
          setConcept({ data: res.keywords, isLoading: false });
        }
      );
    } else {
      getAuthorKeywordsByID(
        faculty_id,
        sliderValue,
        granularityLevel,
        params,
        publicationVerify,
        (res) => {
          setConcept({ data: res.keywords, isLoading: false });
        }
      );
    }
  }, [faculty_id, sliderValue, granularityLevel, publicationVerify, tab]);
  return (
    <div className={styles["faculty-profile-word-map"]}>
      <KeywordCloud
        concept={concept}
        selectedKeywords={selectedKeywords}
        setSelectedKeywords={setSelectedKeywords}
        granularityLevel={granularityLevel}
        setGranularityLevel={setGranularityLevel}
        selectedKeywordsQueue={selectedKeywordsQueue}
        setSelectedKeywordsQueue={setSelectedKeywordsQueue}
        sliderValue={sliderValue}
        setSliderValue={setSliderValue}
        chart_width={
          window.screen.width < 1024
            ? window.screen.width < 900
              ? null
              : 500
            : ""
        }
      />
    </div>
  );
};

export default KeywordCloudFacultyDetail;
